<template>
<div>
  <div id="sidenav" class="sidenav bg-primary-3 text-white links-white">
    <ul class="nav flex-column">

      <profile-link></profile-link>

        <li class="nav-header pt-3 pb-3">
          <span style="padding-left:1rem;">Main</span>
        </li>

        <navigation-link v-for="route in navigationLinks" v-bind:route.sync="route"></navigation-link>
    </ul>

  </div>
</div>
</template>

<script>
import ProfileLink from './components/ProfileLink.vue';
import NavigationLink from './components/NavigationLink.vue';
import { navigationLinks } from './navigation-links.js'
import { cloneDeep } from 'lodash'


export default {
  name: 'Sidebar',
  data: () => ({
    navigationLinks: cloneDeep(navigationLinks)
  }),
  components: {
    ProfileLink, NavigationLink
  },
  computed: {
    count () {
      return this.$store.state.host.properties.length
    }
  },

  watch: {
    'count': function(newVal, oldVal){
      this.loadLinks();
    }
  },
  beforeMount() {

    this.loadLinks();
  },
  mounted(){
    //const collapse = document.querySelectorA('.sidenav a[data-toggle="collapse"]');

    document.querySelector('.sidenav').addEventListener("click", this.toggleCollapse)
  },
  methods: {

    loadLinks: function(){
      let properties = this.$store.state.host.properties;

      console.log("properties")
      console.log(properties);

      this.navigationLinks = cloneDeep(navigationLinks)

      this.navigationLinks.settings.to = '/' + this.$i18n.locale + '/' + this.$t('settings');

      if(properties.length && properties.find(p => p.rooms.length)){

        for(let property of properties){
          this.navigationLinks.calendar.to.push({
            _id: property._id,
            name: property.name,
            to: '/' + this.$i18n.locale + '/' + property.slug + '/' + this.$t('calendar'),
            meta: {
              iconClass: "icon extra-bold",
              iconContent: property.name.match(/\b\w/g).slice(0, 3).join('').toUpperCase()
            }
          });

          this.navigationLinks.bookings.to.push({
            _id: property._id,
            name: property.name,
            to: '/' + this.$i18n.locale + '/' + property.slug + '/' + this.$t('bookings'),
            meta: {
              iconClass: "icon extra-bold",
              iconContent: property.name.match(/\b\w/g).slice(0, 3).join('').toUpperCase()
            }
          });

          this.navigationLinks.guestbook.to.push({
            _id: property._id,
            name: property.name,
            to: '/' + this.$i18n.locale + '/' + property.slug + '/' + this.$t('guests'),
            meta: {
              iconClass: "icon extra-bold",
              iconContent: property.name.match(/\b\w/g).slice(0, 3).join('').toUpperCase()
            }
          });

          this.navigationLinks.locks.to.push({
            _id: property._id,
            name: property.name,
            to: '/' + this.$i18n.locale + '/' + property.slug + '/' + this.$t('locks'),
            meta: {
              iconClass: "icon extra-bold",
              iconContent: property.name.match(/\b\w/g).slice(0, 3).join('').toUpperCase()
            }
          });

          this.navigationLinks.invoices.to.push({
            _id: property._id,
            name: property.name,
            to: '/' + this.$i18n.locale + '/' + property.slug + '/' + this.$t('invoices'),
            meta: {
              iconClass: "icon extra-bold",
              iconContent: property.name.match(/\b\w/g).slice(0, 3).join('').toUpperCase()
            }
          });

          this.navigationLinks.reports.to.push({
            _id: property._id,
            name: property.name,
            to: '/' + this.$i18n.locale + '/' + property.slug + '/' + this.$t('reports'),
            meta: {
              iconClass: "icon extra-bold",
              iconContent: property.name.match(/\b\w/g).slice(0, 3).join('').toUpperCase()
            }
          });
        }

      }else{

        this.navigationLinks = {"settings": this.navigationLinks.settings};

      }

      console.log(this.navigationLinks)

      this.$store.commit('setGuests');
    },
    toggleCollapse: function(e){
      if(event.target.tagName != 'A' || !event.target.attributes["data-toggle"] || event.target.attributes["data-toggle"].value != 'collapse'){
        return;
      }

      const link = e.target;
      const collapse = link.nextSibling;
      const parent = link.parentElement;

      const openCollapse = document.querySelectorAll('.sidenav .collapse.show');
      openCollapse.forEach(c => {
        if(c != collapse){
          c.classList.remove('show');
          c.parentElement.querySelector('a').setAttribute('aria-expanded', 'false');
          c.parentElement.classList.remove('show');
          c.parentElement.removeAttribute("style");
        }
      });

      if(parent.id == 'sidenav-profile' && link.getAttribute('aria-expanded') == 'false'){
        parent.style.backgroundColor = "#07274c";
      }else{
        parent.removeAttribute("style");
      }


      link.setAttribute('aria-expanded', link.getAttribute('aria-expanded') == 'false' ? 'true' : 'false');
      collapse.classList.toggle('show');

      return;
    },


  }
}
</script>

<style>
  .sidenav {
    height: 100%;
    width:88px;
    position: relative;
    z-index: 1;
    top: 0;
    left: 0;
    overflow-x: hidden;
    transition: 0.5s;
  }

  .side-nav .nav .user-sidebar {
    -webkit-box-shadow: 0 1px 0 hsla(0,0%,100%,.05);
    box-shadow: 0 1px 0 hsla(0,0%,100%,.05);
  }

  #sidenav-avatar{
    transition: background .5s linear,color .5s linear;
    transition-property: background, color;
    transition-duration: 0.5s, 0.5s;
    transition-timing-function: linear, linear;
    transition-delay: 0s, 0s;
  }

  .nav-item{
    white-space:nowrap;
  }

  .sidenav .icon{
    width: 3rem;
    text-align:center;
    height: auto;
    min-height: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size:12px;
  }
  .sidenav .icon.pe{
    font-size:25px;
  }

  body.show-sidenav .sidenav{
    width: 270px;
  }

  .sidenav .title{
    display:none;
    transition: all .3s ease-in;
  }
  body.show-sidenav .sidenav .title{
    display:inline-block;
  }

  .side-nav .nav .sidebar .status {
      border: 3px solid #101480;
  }
  .status.online {
      background-color: #35ac19;
  }
  .status.status-right {
      right: 7px;
  }
  .status {
      border: 2px solid #000;
      position: absolute;
      border-radius: 50%;
      height: 12px;
      width: 12px;
      bottom: 2px;
  }
  .avatar {
    height: 3rem !important;
    width: 3rem !important;
  }
  .sidenav a {
    display: flex;
    align-items: center;
  }
  a > * {
    pointer-events:none;
  }

  .collapse {
    display: block !important;
    max-height: 0px !important;
    overflow-y: hidden;
    transition: max-height 0.5s cubic-bezier(0, 1, 0, 1);
  }
  .collapse.show {
    max-height: 99em !important;
    transition: max-height 0.5s ease-in-out;
  }

  body.show-sidenav .sidenav .nav-link[data-toggle="collapse"]:after{
    font-family: Font Awesome\ 5 Free;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    display: inline-block;
    font-style: normal;
    font-variant: normal;
    text-rendering: auto;
    font-weight: 900;
    content: "\F107";
    position: absolute;
    right: 1.5rem;
    line-height: 1;
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: -webkit-transform .2s ease-in-out;
    transition: -webkit-transform .2s ease-in-out;
    transition: transform .2s ease-in-out;
    transition: transform .2s ease-in-out,-webkit-transform .2s ease-in-out;
  }

  body.show-sidenav .sidenav .nav-link[data-toggle="collapse"][aria-expanded="true"]:after{
    -webkit-transform: rotate(180deg);
    -moz-transform:    rotate(180deg);
    -ms-transform:     rotate(180deg);
    -o-transform:      rotate(180deg);
    transform:         rotate(180deg);
  }

  #sidenav-profile{
    -webkit-box-shadow: 0 1px 0 hsla(0,0%,100%,.05);
    box-shadow: 0 1px 0 hsla(0,0%,100%,.05);
  }



  @media screen and (max-width: 450px) {
    .sidenav {
      position:absolute;
      top:72px;
      width:0;
    }

    .sidenav{
      top:70px;
      height:auto;
      min-height: calc(100% - 70px)
    }

    body.show-sidenav .sidenav{
      overflow-y:scroll;
      z-index:1000;
      width:100%;
      left:0;
    }

    body.show-sidenav #main{
      position:fixed;

    }
  }
</style>

<i18n>
{
  "en": {
    "calendar": "calendar",
    "bookings": "bookings",
    "guests": "guests",
    "locks": "locks",
    "invoices": "invoices",
    "reports": "reports",
    "settings": "settings"
  },
  "sl": {
    "calendar": "koledar",
    "bookings": "rezervacije",
    "guests": "gostje",
    "locks": "kljucavnice",
    "invoices": "racuni",
    "reports": "porocila",
    "settings": "nastavitve"
  }
}
</i18n>
